import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

export const RECOVER_FORGOTTEN_PASSWORD = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations

};